import { action } from 'satcheljs';
import { Datapoints } from '../datapoints';

export const clickEditTodoContextMenuItem = action(
    'clickEditTodoContextMenuItem',
    (itemId: string) => ({
        itemId,
        datapointConfig: Datapoints.todoItemActionContextMenuEditSubject.datapoint,
    })
);

export const clickRemoveImportanceContextMenuItem = action(
    'clickRemoveImportanceContextMenuItem',
    (itemId: string) => ({
        itemId,
        datapointConfig: Datapoints.todoItemActionContextMenuRemoveImportance.datapoint,
    })
);

export const clickMarkImportantContextMenuItem = action(
    'clickMarkImportantContextMenuItem',
    (itemId: string) => ({
        itemId,
        datapointConfig: Datapoints.todoItemActionContextMenuMarkImportant.datapoint,
    })
);
